import { useDiscountProductDescriptionQuery } from '@/entities/catalog-discount'
import { useGetProductDescriptionQuery } from '@/entities/product'

import { useIsDiscountProductPage } from './useProduct'

// NB: description is NOT part of the SSR context — the CMS DETAIL_TEXT is a full HTML document that
// doesn't survive SSR + browser innerHTML normalization identically (hydration mismatch), so it stays
// client-fetched (rendered after hydration, no SSR comparison).
// Discount product pages use `discount/products/{id}/description` instead of `/products/{id}/description`.
export function useProductDescriptionData(productId: number) {
	const isDiscountProductPage = useIsDiscountProductPage()
	const discountProductId = isDiscountProductPage && productId ? String(productId) : ``

	const discountQuery = useDiscountProductDescriptionQuery(discountProductId)
	const query = useGetProductDescriptionQuery(productId, {
		skip: !productId || isDiscountProductPage
	})

	if (isDiscountProductPage) {
		return {
			data: discountQuery.data,
			isLoading: discountQuery.isLoading,
			isError: discountQuery.isError,
			error: discountQuery.error
		}
	}

	return {
		data: query.data,
		isLoading: query.isLoading,
		isError: query.isError,
		error: query.error
	}
}
